import { BehaviorSubject } from 'rxjs'
import { BookedService, BookedServicesApi, ExamDto, ExamApi, ServiceDto, ServicesApi, ShowApi, Starter, StartersApi } from '../api'
import { ShowDto } from '../types/ShowDto'
import { authState } from './Auth.state'

export interface ActualShowState {
  loading$: BehaviorSubject<boolean>
  actualShowNr$: BehaviorSubject<number | undefined>
  actualShow$: BehaviorSubject<ShowDto | undefined>
  actualShowServices$: BehaviorSubject<ServiceDto[]>
  actualShowExams$: BehaviorSubject<ExamDto[]>
  actualShowStarters$: BehaviorSubject<Starter[]>
  actualShowBookedServices$: BehaviorSubject<BookedService[]>
  fetchShowForNr: (id: number) => Promise<ShowDto>
  fetchServicesForNr: (id: number, bookerId: string) => Promise<ServiceDto[]>
  fetchExamsForNr: (id: number, bookerId: string) => Promise<ExamDto[]>
  fetchStartersForOwnerIdAndShow: (bookerId: string, showId: number) => Promise<Starter[]>
  fetchBookedServicesForOwnerIdAndShow: (bookerId: string, showId: number) => Promise<BookedService[]>
}

export const actualShowState: ActualShowState = {
  loading$: new BehaviorSubject<boolean>(false),
  actualShowNr$: new BehaviorSubject<number | undefined>(undefined),
  actualShow$: new BehaviorSubject<ShowDto | undefined>(undefined),
  actualShowServices$: new BehaviorSubject<ServiceDto[]>([]),
  actualShowExams$: new BehaviorSubject<ExamDto[]>([]),
  actualShowStarters$: new BehaviorSubject<Starter[]>([]),
  actualShowBookedServices$: new BehaviorSubject<BookedService[]>([]),
  fetchShowForNr: async (id: number) => {
    const raw = await new ShowApi(authState.apicfg()).apiShowBookableIdGetRaw({ id })
    return await raw.raw.json() as ShowDto
  },
  fetchServicesForNr: async (id: number, bookerId: string) => {
    return await new ServicesApi(authState.apicfg()).apiServicesByShowShowIdBookerBookerIdGet({ showId: id, bookerId })
  },
  fetchExamsForNr: async (id: number, bookerId: string) => {
    return new ExamApi(authState.apicfg()).apiExamByShowShowIdBookerBookerIdGet({ showId: id, bookerId })
  },
  fetchStartersForOwnerIdAndShow: async (bookerId: string, showId: number) => {
    return new StartersApi(authState.apicfg()).apiStartersShowShowIdBookerBookerIdGet({ bookerId, showId })
  },
  fetchBookedServicesForOwnerIdAndShow: async (bookerId: string, showId: number) => {
    return new BookedServicesApi(authState.apicfg()).apiBookedServicesShowShowIdBookerBookerIdGet({ bookerId, showId })
  }
}
